"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVimeoContentStyle;
function createVimeoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVWaW1lb0NvbnRlbnRTdHlsZSIsIl9yZWYiLCJ2aWRlb0hlaWdodCIsImJvcmRlciIsImhlaWdodCIsIndpZHRoIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L1ZpbWVvQ29udGVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVWaW1lb0NvbnRlbnRTdHlsZSh7IHZpZGVvSGVpZ2h0IH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIGJvcmRlcjogMCxcbiAgICBoZWlnaHQ6IHZpZGVvSGVpZ2h0LFxuICAgIHdpZHRoOiAnMTAwJSdcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRWUsU0FBU0EsdUJBQXVCQSxDQUFBQyxJQUFBLEVBQXNDO0VBQUEsSUFBbkNDLFdBQVcsR0FBQUQsSUFBQSxDQUFYQyxXQUFXO0VBQzNELE9BQU87SUFDTEMsTUFBTSxFQUFFLENBQUM7SUFDVEMsTUFBTSxFQUFFRixXQUFXO0lBQ25CRyxLQUFLLEVBQUU7RUFDVCxDQUFDO0FBQ0gifQ==